import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  purpose: yup
    .string()
    .required('Please enter a purpose')
    .max(255, 'Please enter a shorter purpose'),
})

export const fieldNames = ['purpose', 'purposeIsCompleted']
